<template>
  <div class="border mt-2">
    <div class="title">
      {{ cat.nome_categoria }}
    </div>
    <table>
      <thead>
      <tr>
        <th v-for="col in previewLayout" :key="col.key"
            :style="getColStyle(col)">
          {{ resolveHeaderLabel(col) }}
        </th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="(r, index) in reunioesPreview" :key="`rPrev${index}`">
        <td v-for="col in previewLayout" :key="col.key" :style="getColStyle(col)">
          <img v-if="col.icon === 'libras' && r.libras" :src="getIconSrc('libras')" alt="Libras" class="libras">
          <span v-html="r[col.key] || '-'"></span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { PREVIEW_LAYOUTS } from '@/configs/previewLayout';

export default {
  name: "CategoriaPreview",
  props: ['cat', 'noPrint', 'showCategoria'],

  methods: {
    resolveHeaderLabel(col) {
      // regra especial: presidência customizável
      if (col.key === 'presidencia') {
        return this.cat.presidencia || col.label || 'Ancião';
      }

      return col.label || '';
    },

    getColStyle(col) {
      const style = {};

      if (col.width) {
        style.width = col.width;
      }

      if (col.nowrap) {
        style.whiteSpace = 'nowrap';
      }

      if (col.align) {
        style.textAlign = col.align;
      }

      if (col.multiline) {
        style.whiteSpace = 'pre-line';
      }

      return style;
    },

    getIconSrc(icon) {
      if (icon === 'libras') {
        return require('@/assets/icones/libras.png');
      }

      return '';
    },

    formatLocalidade(r) {
      if (r.localidade) {
        return r.localidade;
      }

      if (r.nome_cidade || r.nome_localidade) {
        return [r.nome_cidade, r.nome_localidade]
            .filter(Boolean)
            .join(' - ');
      }

      return '-';
    },

    formatDataComDia(r) {
      return `${r.data_reuniao} ${this.diaLabel(r.dia)}`;
    },

    diaLabel(d) {
      return ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB', 'DOM'][d] || '';
    },

    formatReuniaoLayout2(r) {
      if (+this.cat.layout !== 2) return null;

      return [
        r.nome_reuniao,
        r.localidade || '',
        `<strong>${r.presidencia || ''}</strong>`
      ].filter(Boolean).join('\n');
    },

    formatPresidenciaLayout3(r) {
      if (+this.cat.layout !== 3) return r.presidencia || '';

      return [r.presidencia || '', r.presidencia_2 || '']
          .filter(Boolean)
          .join('\n');
    },

    formatEnderecoCompleto(r) {
      if (+this.cat.layout !== 4) return r.localidade || '';

      if (r.localidade && r.endereco && r.numero && r.bairro) {
        return [r.localidade, r.endereco, r.numero, r.bairro].filter(Boolean).join(', ');
      }

      return '-'
    },

    diaMes(data) {
      if (!data) {
        return '';
      }

      const value = String(data);
      const slashParts = value.split('/');
      if (slashParts.length === 2) {
        return slashParts[0];
      }

      const dashParts = value.split('-');
      return dashParts.length === 3 ? dashParts[2] : '';
    },

    mesAbrev(data) {
      if (!data) {
        return '';
      }

      const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
      const value = String(data);
      const slashParts = value.split('/');
      let mes = slashParts.length === 2 ? parseInt(slashParts[1], 10) : null;

      if (!mes) {
        const dashParts = value.split('-');
        mes = dashParts.length === 3 ? parseInt(dashParts[1], 10) : null;
      }

      return mes ? (meses[mes - 1] || '') : '';
    }
  },

  computed: {
    printKey() {
      return `r${this.cat.id_lista_categoria}`;
    },

    previewLayout() {
      return PREVIEW_LAYOUTS[this.cat.layout] || PREVIEW_LAYOUTS[1];
    },

    reunioesPreview() {
      return (this.cat.reunioes || []).map(r => ({
        ...r,

        // dia
        data_com_dia: this.formatDataComDia(r),

        // localidade SEMPRE tratada
        localidade: this.formatLocalidade(r),

        // layout 2
        reuniao_composta: this.formatReuniaoLayout2(r),

        // layout 3
        presidencia_composta: this.formatPresidenciaLayout3(r),

        // layout 4
        localidade_completa: this.formatEnderecoCompleto(r)
      }));
    }
  }
}
</script>
